<template>
  <Modal v-model="model"  sticky reset-drag-position title="编辑服务组菜单" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="shuttle_frame_addbt"  width="700">
    <div class="pop_top"  style="min-height:180px">
        <div class="dept_edit_input">
          <div class="font_style_set">&emsp;上级服务组:</div>
          <Select v-model="serGroup" :disabled="disabled" >
            <Option v-for="(option, index) in groupList" :value="option.id" :key="index">{{option.groupName}}</Option>
          </Select>
        </div>
        <div class="dept_edit_input">
          <div class="font_style_set" ><span style="color: red;margin-right: 5px">*</span>服务组名称:</div>
          <Input v-model="groupName" :maxlength="250"/>
        </div>
        <div class="dept_edit_input">
          <div class="font_style_set">服务组说明:</div>
          <Input v-model="deptDescr" type="textarea" :autosize="{minRows:3,maxRows:3}" :maxlength="250"/>
        </div>
    </div>

    <div class="listcontain">
      <div class="shuttle_left">
        <div class="font_style_title"><Checkbox v-model="leftgroupAll" @on-change="sourceLeft"></Checkbox>源列表</div>
        <Input suffix="ios-search" v-model="sourceLeftValue" placeholder="搜索查询" @on-change="sourceLeftSearch"/>
        <CheckboxGroup v-model="shuttleLeftList" style="height:200px!important;">
          <Checkbox v-for="(item,index) in leftgroupData" :key="index" :label="item.id">{{item.agentNum}}</Checkbox>
        </CheckboxGroup>
      </div>
      <div class="shuttle_middle" style="line-height:150px;height:200px">
        <Button type="info" class="right" :disabled="shuttleLeftList.length==0" @click="moveToRight">右移</Button>
        <Button type="info" class="left"  :disabled="shuttleRightList.length==0" @click="moveToLeft">左移</Button>
      </div>
      <div class="shuttle_right">
        <div class="font_style_title"><Checkbox v-model="rightgroupAll" @on-change="sourceRight"></Checkbox>目标列表</div>
        <Input suffix="ios-search" v-model="sourceRightValue" placeholder="搜索查询" @on-change="sourceRightSearch"/>
        <CheckboxGroup v-model="shuttleRightList" style="height:200px!important;">
          <Checkbox v-for="(item,index) in rightgroupData" :key="index" :label="item.employeeId">
            <span>{{item.agentNum}}</span>
          </Checkbox>
        </CheckboxGroup>
      </div>
    </div>
    <div class="btn_template">
        <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
        <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
    export default {
      name: "EditgroupPop",
      props:{
        groupList:Array,
        deptId:String,
        title:String,
        pid:String,
        showEditGroup:Boolean,
        serviceId:String
      },
      data(){
        return{
          disabled:true,
          serGroup:'',
          groupName:'',
          deptDescr:'',
          model:false,
          shuttleLeftList:[],
          shuttleRightList:[],
          initleftData:[],
          leftgroupData:[],
          initTargetData:[],
          rightgroupData: [],
          leftgroupAll:false,
          rightgroupAll:false,
          movesNumber:0,
          sourceLeftValue:'',
          sourceRightValue:'',
        }
      },
      methods:{
        //左边查询
        sourceLeftSearch:function(){
          this.leftgroupData=[];
          if(!this.sourceLeftValue){
            this.leftgroupData=this.initleftData;
            return false;
          }
          for (let i=0;i<this.initleftData.length;i++){
            let agentNum=this.initleftData[i].agentNum;
            if(agentNum && agentNum.indexOf(this.sourceLeftValue)!=-1){
              this.leftgroupData.push(this.initleftData[i]);
            }
          }
        },
        //右边查询
        sourceRightSearch:function(){
          this.rightgroupData=[];
          if(!this.sourceRightValue){
            this.rightgroupData=this.initTargetData;
            return false;
          }
          for (let i=0;i<this.initTargetData.length;i++){
            let agentNum=this.initTargetData[i].agentNum;
            if(agentNum && agentNum.indexOf(this.sourceRightValue)!=-1){
              this.rightgroupData.push(this.initTargetData[i]);
            }
          }
        },
        //左边全选
        sourceLeft:function(){
          this.shuttleLeftList=[];
          if(this.leftgroupAll){
            for (let i=0;i<this.leftgroupData.length;i++){
              this.shuttleLeftList.push(this.leftgroupData[i].id);
            }
          }
        },
        //右边全选
        sourceRight:function(){
          this.shuttleRightList=[];
          if(this.rightgroupAll){
            for (let i=0;i<this.rightgroupData.length;i++){
              this.shuttleRightList.push(this.rightgroupData[i].employeeId);
            }
          }
        },
        moveToLeft:function(){
          let list=this.shuttleRightList;
          this.rightgroupAll=false;
          this.shuttleRightList=[];
          for (let i=0;i<list.length;i++){
            let id=list[i];
            for (let k=0;k<this.rightgroupData.length;k++){
             if(id==this.rightgroupData[k].employeeId){
                let param={
                  id:id,
                  agentNum:this.rightgroupData[k].agentNum
                };
                this.leftgroupData.unshift(param);
                let count=0;
                for (let a=0;a<this.initleftData.length;a++){
                 if(id==this.initleftData[a].id){
                   count++;
                 }
               }
               if(count==0){
                 this.initleftData.unshift(param);
               }
             }
            }
          }
          let newList=[];
          for (let b=0;b<this.rightgroupData.length;b++){
            if(list.indexOf(this.rightgroupData[b].employeeId)=="-1"){
              newList.push(this.rightgroupData[b]);
            }
          }
          let initNewList=[];
          for (let m=0;m<this.initTargetData.length;m++){
            if(list.indexOf(this.initTargetData[m].employeeId)=="-1"){
              initNewList.push(this.initTargetData[m]);
            }
          }
          this.rightgroupData=newList;
          this.initTargetData=initNewList;
          this.movesNumber++;
        },
        moveToRight:function(){
          let list=this.shuttleLeftList;
          this.leftgroupAll=false;
          this.shuttleLeftList=[];
          for (let i=0;i<list.length;i++){
            let id=list[i];
            for (let k=0;k<this.leftgroupData.length;k++){
              if(id==this.leftgroupData[k].id){
                let param={
                  employeeId:id,
                  level:'0',
                  agentNum:this.leftgroupData[k].agentNum
                };
                this.rightgroupData.unshift(param);
                let count=0;
                for (let a=0;a<this.initTargetData.length;a++){
                  if(id==this.initTargetData[a].employeeId){
                    count++;
                  }
                }
                if(count==0){
                  this.initTargetData.unshift(param);
                }
              }
            }
          }
          let newList=[];
          for (let b=0;b<this.leftgroupData.length;b++){
            if(list.indexOf(this.leftgroupData[b].id)=="-1"){
              newList.push(this.leftgroupData[b]);
            }
          }
          let initNewList=[];
          for (let m=0;m<this.initleftData.length;m++){
            if(list.indexOf(this.initleftData[m].id)=="-1"){
              initNewList.push(this.initleftData[m]);
            }
          }
          this.leftgroupData=newList;
          this.initleftData=initNewList;
          this.movesNumber++;
        },
        cancel:function () {
          this.$emit("closeEditGroup",false);
        },
        save:function () {
          let that=this;
          if(!this.groupName){
              this.$Modal.info({
                title:'提示',
                content:"服务组名称不能为空"
              });
              return false;
          }
          this.$Modal.confirm({
            title: '提示',
            content: "是否确定保存当前修改",
            onOk: () => {
              that.sourceRightValue = "";
              let agentRight=[];
              for (let m=0;m<that.initTargetData.length;m++){
                agentRight.push(that.initTargetData[m].employeeId+"-"+that.initTargetData[m].agentNum+"-"+that.initTargetData[m].level);
              }
              if(!this.serGroup){
                this.serGroup = "0";
              }
              let param={
                    id:this.deptId,
                    pid:this.serGroup,
                    groupName:this.groupName,
                    descr:this.deptDescr,
                    journalType:"系统管理=>工单配置=>工单服务组=>编辑",
                    agentRight:agentRight.toString(),
                    menuId:"3_d-1-3"
              };
              this.$http.post("/orderGroup/doSave.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                that.$Message.success("操作成功");
                that.$emit("closeEditGroup",true);
              });
            }
          });
        },
        init:function () {
          let that=this;
          let param={
            id:this.serviceId,
            journalType:"null",
            menuId:"null"
          };
            this.$http.post("orderGroup/toEdit.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.leftgroupData=res.data.obj.employeeList;
            that.initleftData=res.data.obj.employeeList;
            that.rightgroupData=res.data.obj.list;
            that.initTargetData=res.data.obj.list;
          });
        },
        initSearch:function (id) {
            let param={
              id:id,
              journalType:"null",
              menuId:"null"
            };
            let that=this;
            this.$http.post("orderGroup/toIndex.json",param) .then(function (res) {
              let result=res.data.flag;
              if(result!="666"){
                that.$Modal.info({
                  title:'提示',
                  content:res.data.msg
                });
                return false;
              }
              let list=res.data.obj.tree;
              if(list.length>0){
                that.groupName=list[0].groupName;
                that.deptDescr=list[0].descr;
              }
            });
        }
      },
      watch:{
        showEditGroup:function () {
          this.model=this.showEditGroup;
          this.groupName="";
          this.deptDescr="";
          this.sourceLeftValue = "";
          this.sourceRightValue = "";
          if(this.showEditGroup){
            this.leftgroupAll=false;
            this.rightgroupAll=false;
            this.movesNumber=0;
            this.shuttleLeftList=[];
            this.shuttleRightList=[];
            this.leftgroupData=[];
            this.initleftData=[];
            this.rightgroupData=[];
            this.initTargetData=[];
            this.init();
            if(this.deptId){//添加时此值为空,编辑时有值
                this.initSearch(this.deptId);
                for (let i=0;i<this.groupList.length;i++){
                  let id=this.groupList[i].id;
                  if(id==this.deptId){
                    let pid=this.groupList[i].pid;
                    this.serGroup=pid;
                  }
                }
                return false;
            }
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/worknote/EditgroupPop.vue